/* PupTailor buy box: scroll to the first missing personalization field after an add-to-cart
   attempt, and a mobile sticky purchase bar. Globo keeps its own validation and messages. */
(function () {
  var pi = document.querySelector('product-info[id^="MainProduct-"]');
  if (!pi) return;

  function visibleSubmit() {
    var all = pi.querySelectorAll('.product-form__submit');
    for (var i = 0; i < all.length; i++) if (all[i].offsetParent !== null) return all[i];
    return all[0] || null;
  }

  function firstMissing() {
    var els = pi.querySelectorAll('.pt-personalize .gpo-element');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.offsetParent === null) continue;
      var msg = el.querySelector('.messages');
      if ((msg && msg.textContent.trim()) || /\b(gpo-error|has-error|error)\b/.test(el.className)) return el;
    }
    return null;
  }

  function revealMissing() {
    var el = firstMissing();
    if (!el) return;
    var r = el.getBoundingClientRect();
    if (r.top < 80 || r.bottom > window.innerHeight - 80) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var control = el.querySelector('input:not([type="hidden"]), textarea, select, button');
    if (control) control.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product-form__submit');
    if (!btn || !pi.contains(btn) || pi.hasAttribute('data-pt-locked')) return;
    setTimeout(revealMissing, 180);
  });

  /* Mobile sticky bar */
  if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
  var row = pi.querySelector('.pt-purchase-row') || (visibleSubmit() && visibleSubmit().closest('product-form'));
  var title = pi.querySelector('.product__title h1');
  var priceBox = pi.querySelector('[id^="price-"]');
  if (!row || !priceBox) return;

  var bar = document.createElement('div');
  bar.className = 'pt-sticky-buy';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML = '<div class="pt-sticky-buy__meta"><span class="pt-sticky-buy__title"></span><span class="pt-sticky-buy__price"></span></div><button type="button" class="pt-sticky-buy__btn" tabindex="-1"></button>';
  document.body.appendChild(bar);
  var nameEl = bar.querySelector('.pt-sticky-buy__title');
  var priceEl = bar.querySelector('.pt-sticky-buy__price');
  var btnEl = bar.querySelector('.pt-sticky-buy__btn');

  function currentPrice() {
    var sale = priceBox.querySelector('.price--on-sale .price-item--sale');
    var reg = priceBox.querySelector('.price__regular .price-item--regular');
    return ((sale || reg || priceBox).textContent || '').replace(/\s+/g, ' ').trim();
  }
  function refresh() {
    var main = visibleSubmit();
    var label = main && main.querySelector('span');
    nameEl.textContent = title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
    priceEl.textContent = currentPrice();
    btnEl.textContent = label ? label.textContent.trim() : 'Add to cart';
    btnEl.disabled = !!(main && main.disabled && !pi.hasAttribute('data-pt-locked'));
  }
  function update() {
    var r = row.getBoundingClientRect();
    var show = r.bottom < 0;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    btnEl.tabIndex = show ? 0 : -1;
    if (show) refresh();
  }
  btnEl.addEventListener('click', function () {
    if (pi.hasAttribute('data-pt-locked')) {
      var panel = pi.querySelector('.pt-personalize');
      if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var main = visibleSubmit();
    if (main && !main.disabled) main.click();
  });
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; update(); });
  }, { passive: true });
  if (window.MutationObserver) new MutationObserver(function () { if (bar.classList.contains('is-visible')) refresh(); }).observe(priceBox, { childList: true, subtree: true, characterData: true });
  refresh();
  update();
})();
